/** Toggle updateCharts so scatter plots redraw even when already true (e.g. after target change). */
export function forcePerformanceChartUpdate(
  setUpdateCharts: (value: boolean) => void
): void {
  setUpdateCharts(false);
  setTimeout(() => setUpdateCharts(true), 0);
}
